import { getLocalApi } from "./localApi";
import { TransferType} from "app/shared/model";
import apiConfig from "app/api/apiConfig.json";

export async function getAllTransferTypes() : Promise<TransferType[]> {
    const localApi = await getLocalApi();

    return await localApi.fetchList(apiConfig.reference_data_get_transfer_types, (dto:any) => ({
        name: dto.name,
        id: dto.id
    }), 'Unable to fetch transfer types')
}